import React, { useState, useEffect, useCallback } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import {
  Lightning, X, Lightbulb, Fan, Thermometer, Lock,
  VideoCamera, Fire, Power
} from '@phosphor-icons/react';

const ICON_MAP = {
  Lightbulb, Fan, Thermometer, Lock, VideoCamera, Fire, Power, Lightning,
};

export function QuickActionsPanel({ onClose }) {
  const { api } = useAuth();
  const [pins, setPins] = useState([]);
  const [toggling, setToggling] = useState('');

  const fetchPins = useCallback(async () => {
    try {
      const res = await api.get('/scenes/quick-actions');
      setPins(res.data.pins || []);
    } catch (e) { console.error(e); }
  }, [api]);

  useEffect(() => { fetchPins(); }, [fetchPins]);

  const handleToggle = async (deviceId) => {
    setToggling(deviceId);
    try {
      await api.post(`/scenes/quick-actions/${deviceId}/toggle`);
    } catch (e) { console.error(e); }
    setTimeout(() => setToggling(''), 600);
  };

  return (
    <div className="fixed inset-0 z-50" data-testid="quick-actions-panel">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} />
      <div className="absolute bottom-20 left-4 right-4 max-w-sm mx-auto animate-in slide-in-from-bottom-4">
        <div className="rounded-3xl overflow-hidden" style={{ background: '#141414', border: '1px solid rgba(255,255,255,0.08)' }}>
          <div className="px-5 py-4 flex items-center justify-between border-b border-white/5">
            <div className="flex items-center gap-2">
              <Lightning size={18} weight="fill" className="text-[#FF6B35]" />
              <h3 className="text-sm font-bold text-white">Quick Actions</h3>
            </div>
            <button onClick={onClose} className="w-7 h-7 rounded-lg bg-white/5 flex items-center justify-center" data-testid="quick-actions-close">
              <X size={14} className="text-neutral-400" />
            </button>
          </div>

          <div className="p-4 grid grid-cols-3 gap-3">
            {pins.map(pin => {
              const Icon = ICON_MAP[pin.icon] || Lightning;
              const isToggling = toggling === pin.device_id;
              return (
                <button
                  key={pin.device_id}
                  data-testid={`quick-action-${pin.device_id}`}
                  onClick={() => handleToggle(pin.device_id)}
                  disabled={isToggling}
                  className={`flex flex-col items-center gap-2 p-4 rounded-2xl transition-all active:scale-95 ${isToggling ? 'bg-[#FF6B35]/15' : 'bg-white/[0.03] hover:bg-white/[0.06]'}`}
                  style={{ border: '1px solid rgba(255,255,255,0.06)' }}
                >
                  <div className={`w-11 h-11 rounded-xl flex items-center justify-center transition-colors ${isToggling ? 'bg-[#FF6B35]/20' : 'bg-white/5'}`}>
                    <Icon size={22} weight="fill" className={isToggling ? 'text-[#FF6B35]' : 'text-neutral-400'} />
                  </div>
                  <span className="text-[11px] font-medium text-neutral-400 text-center leading-tight">{pin.label}</span>
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
